import { render, staticRenderFns } from "./ComingSoon.vue?vue&type=template&id=036b92a2&scoped=true"
import script from "./ComingSoon.vue?vue&type=script&lang=js"
export * from "./ComingSoon.vue?vue&type=script&lang=js"
import style0 from "./ComingSoon.vue?vue&type=style&index=0&id=036b92a2&prod&lang=css"
import style1 from "./ComingSoon.vue?vue&type=style&index=1&id=036b92a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036b92a2",
  null
  
)

export default component.exports